import {Box, Flex, Grid, Heading, Text} from "@chakra-ui/react"
import {Link as RouterLink} from "react-router-dom"
import {useTranslation} from "react-i18next"
import React from "react"

interface AuthShellProps {
    narrow?: boolean
    brand?: React.ReactNode
    brandFoot?: React.ReactNode
    children: React.ReactNode
}

const DefaultBrand = () => {
    const {t} = useTranslation()
    return (
        <>
            <Text
                fontFamily="mono"
                fontSize="11px"
                letterSpacing="0.2em"
                textTransform="uppercase"
                color="#84C3FF"
            >
                {t('auth.brand.eyebrow')}
            </Text>
            <Heading
                fontFamily="heading"
                fontWeight={800}
                letterSpacing="-0.02em"
                fontSize="clamp(34px,4vw,52px)"
                color="white"
                mt="18px"
                lineHeight={1.04}
            >
                {t('auth.brand.line1')}<br/>
                {t('auth.brand.line2')}
            </Heading>
            <Text
                mt="18px"
                color="#A3A3A3"
                fontSize="16px"
                maxW="380px"
                lineHeight={1.6}
            >
                {t('auth.brand.body')}
            </Text>
        </>
    )
}

const DefaultBrandFoot = () => {
    /* HIDDEN_TODO #31 — auth-panel stats hidden: the numbers (180+/12k/4.8★)
       were fabricated; bring back wired to a real BE stats endpoint.
       See docs/HIDDEN_TODO.md.
    const {t} = useTranslation()
    const stats = [
        {n: '180+', label: t('auth.brand.stats.shops')},
        {n: '12k', label: t('auth.brand.stats.bookings')},
        {n: '4.8★', label: t('auth.brand.stats.rating')},
    ]
    return (
        <Flex position="relative" zIndex={2} gap="30px">
            {stats.map(({n, label}) => (
                <Box key={label}>
                    <Text fontFamily="heading" fontWeight={800} fontSize="26px" color="white">
                        {n}
                    </Text>
                    <Text
                        fontFamily="mono"
                        fontSize="10.5px"
                        letterSpacing="0.12em"
                        color="#737373"
                        textTransform="uppercase"
                    >
                        {label}
                    </Text>
                </Box>
            ))}
        </Flex>
    )
    */
    return null
}

export default function AuthShell({narrow, brand, brandFoot, children}: AuthShellProps) {
    return (
        <Grid minH="100vh" templateColumns={{base: "1fr", md: "1.05fr 1fr"}}>
            <Box
                display={{base: "none", md: "flex"}}
                bg="#171717"
                color="white"
                p="48px 56px"
                flexDirection="column"
                justifyContent="space-between"
                position="relative"
                overflow="hidden"
            >
                <Box position="relative" zIndex={2}>
                    <RouterLink to="/" style={{textDecoration: "none"}}>
                        <Text
                            as="span"
                            fontFamily="heading"
                            fontWeight={700}
                            fontSize="22px"
                            letterSpacing="-0.04em"
                            color="white"
                        >
                            BARBER<Text as="span" color="#FF3D3D">MATE</Text>
                        </Text>
                    </RouterLink>
                </Box>

                <Box position="relative" zIndex={2}>
                    {brand ?? <DefaultBrand/>}
                </Box>

                <Box position="relative" zIndex={2}>
                    {brandFoot ?? <DefaultBrandFoot/>}
                </Box>

                <Box
                    position="absolute"
                    right="-80px"
                    top="30%"
                    w="340px"
                    h="340px"
                    borderRadius="50%"
                    bg="rgba(0,136,255,0.16)"
                    filter="blur(70px)"
                    pointerEvents="none"
                />
                <Box
                    position="absolute"
                    left="-60px"
                    bottom="-40px"
                    w="240px"
                    h="240px"
                    borderRadius="50%"
                    bg="rgba(255,61,61,0.12)"
                    filter="blur(60px)"
                    pointerEvents="none"
                />
            </Box>

            <Flex
                alignItems="center"
                justifyContent="center"
                p={{base: "32px 20px", md: "48px 32px"}}
                bg="#FAFAFA"
            >
                <Box w="full" maxW={narrow ? "380px" : "460px"}>
                    {children}
                </Box>
            </Flex>
        </Grid>
    )
}
